function updateBannerSize() {
    $('.video-banner').find('video').css('height', '');
    $('.video-banner').find('video').css('height', $('.video-banner').outerHeight());
}

function getVideos() {
    var windowWidth = $(window).width();
    var devicePixelRatio = window.getDevicePixelRatio();
    // console.log(windowWidth, devicePixelRatio);
    $('[data-video-inject]').each(function() {
        var $video = $(this);
        var fallbackSources = $($(this).data('fallback')).html();
        var $sources = $($(this).data('video-inject'));
        $video.html(fallbackSources);
        $sources.find('>div').each(function() {
            var minWidth = $(this).data('min-width');
            var minPixelRatio = $(this).data('min-pixel-ratio');
            if (!minPixelRatio || devicePixelRatio >= minPixelRatio) {
                if (!minWidth || windowWidth >= minWidth) {
                    // console.log(minWidth, minPixelRatio);
                    $(this).find('span').each(function() {
                        $video.append('<source type="' + $(this).data('type') + '" src="' + $(this).data('src') + '">');
                    });
                    $video[0].load();
                    return false;
                }
            }
        });
    });
}
window.getDevicePixelRatio = function() {
    var ratio = 1;
    // To account for zoom, change to use deviceXDPI instead of systemXDPI
    if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) {
        // Only allow for values > 1
        ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
    } else if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
    }
    return ratio;
};
jQuery(document).ready(function($) {
    getVideos();
    $('[data-video-inject]').each(function() {
        var $video = $(this);
        $video[0].load();
    });
    var interval;
    updateBannerSize();
    $(window).resize(function() {
        clearTimeout(interval);
        interval = setTimeout(function() {
            updateBannerSize();
            getVideos();
        }, 500);
    });
});